import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import { ArrowDropDown } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  Button as MButton,
  TextField,
} from "@mui/material";
import SaveAsIcon from "@mui/icons-material/SaveAs";
import ClearIcon from "@mui/icons-material/Clear";
import { ChangeEvent, useEffect, useState } from "react";
import { GetRolesList } from "../../services/RoleService";
import {
  DeletePositionService,
  GetPositionById,
  GetPositionByUser,
  UpdatePosition,
} from "../../services/PositionService";
import { GetUserProfileById } from "../../services/ProfileService";

export interface PositionDTO {
  id: any;
  companyId: any;
  userId: any;
  name: string;
  parentPositionId: any;
  roles: [];
}

const ManagePosition = (props: any) => {
  const { positionId, flag, setRefresh } = props; // استخراج مقدار از props
  const formik = useFormik<PositionDTO>({
    initialValues: {
      id: null,
      companyId: null,
      parentPositionId: null,
      userId: null,
      name: "",
      roles: [],
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("لطفا سمت را وارد نمایید"),
    }),
    onSubmit: async (values) => {
      console.log("val", values);
      // return;
      await UpdatePosition(values)
        .then(() => toast.success("تغییرات با موفقیت اعمال شدند"))
        .then(() => setRefresh());
    },
  });

  const location = useLocation();
  const navigate = useNavigate();
  //const params = useParams();
  const [getRolesState, setRolesState] = useState([]);
  const [getPosition, setPosition] = useState<any>();
  const [getUserIds, setUserIds] = useState([]);
  const [getRolesWithFlag, setRolesWithFlag] = useState<any>();
  const [getUsersInfo, SetUsersInfo] = useState<any>([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionId, setSelectedOptionId] = useState(null);
  const [selectedPositionId, setSelectedPositionId] = useState(null);
  const [selectedFlag, setSelectedFlag] = useState("");

  async function getUserInfoById(id: any) {
    return await GetUserProfileById(id);
  }
  async function getPositionsWithRoles() {
    return await GetPositionById(selectedPositionId);
  }
  async function getRoles() {
    return await GetRolesList();
  }
  async function GetPositionsByUserAsync() {
    await GetPositionByUser();
  }

  function SetUpNew() {
    console.log("new is on ");
    setSelectedOption(null);
    formik.resetForm();
  }
  function SetUpEdit() {
    //console.log("edit");
    getPositionsWithRoles().then((p) => {
      //console.log("SetUpEdit p.data ", p.data);
      setPosition(p.data);
    });
  }
  useEffect(() => {
    getRoles().then((p) => setRolesState(p.data.data));
    GetPositionByUser().then((p) => setUserIds(p.data.userIds));
    console.log("pf", selectedFlag);
    if (selectedFlag && selectedFlag.toLowerCase() === "new") {
      console.log("n");
      SetUpNew();
    } else {
      SetUpEdit();
    }
  }, []);

  useEffect(() => {
    console.log("Selected Key:", positionId);
    console.log("Flag:", flag);
    setSelectedPositionId(positionId);
    setSelectedFlag(flag);
  }, [props]);

  useEffect(() => {
    //console.log("getRolesState", getRolesState);
    const newListWithFlag = getRolesState.map((item: any) => ({
      ...item,
      flag: false,
    }));
    setRolesWithFlag(newListWithFlag);
  }, [getRolesState]);

  const setOptionValue = () => {
    if (selectedOptionId) {
      formik.setFieldValue("userId", selectedOptionId);
      console.log("getUsersInfo", getUsersInfo);

      const option = getUsersInfo.find(
        (option: any) => option.id === selectedOptionId
      );
      console.log("option u ", option);

      setSelectedOption(option);
    }
  };

  const DeletePosition = () => {
    // console.log("Del");
    // console.log("selectedOption", selectedOption);
    if (selectedOption) {
      toast.error(" لطفا ابتدا ذی سمت را برابر نامشخص قرار دهید ! ");
    } else {
      DeletePositionAsync(selectedPositionId);
      //console.log(getUsersInfo);
    }
  };

  async function DeletePositionAsync(id: any) {
    await DeletePositionService({ positionId: id }).then((p) => {
      if (p.data.statusCode === 200) {
        setRefresh();
        toast.success("تغییرات با موفقیت اعمال شدند");
      } else {
        setRefresh();
        toast.error(p.data.message);
      }
    });
  }

  useEffect(() => {
    console.log("getUserIds", getUserIds);
    SetUsersInfo([{ id: null, name: "نامشخص" }]);
    getUserIds.forEach((p) => {
      getUserInfoById(p).then((d: any) => {
        console.log("f", d);
        if (d.data.data) {
          SetUsersInfo((f: any) => [
            ...f,
            {
              id: d.data.data.id,
              name: d.data.data.firstName + " " + d.data.data.lastName,
            },
          ]);
        }
      });

      //
    });
    setOptionValue();
  }, [getUserIds]);

  useEffect(() => {
    if (selectedFlag && selectedFlag.toLowerCase() === "new") {
      console.log("updated id or flag new", selectedPositionId, selectedFlag);

      SetUpNew();
      formik.setFieldValue("parentPositionId", selectedPositionId);
    } else {
      //console.log("updated id or flag edit", params.id, params.flag);
      SetUpEdit();
    }
  }, [selectedPositionId, selectedFlag]);

  useEffect(() => {
    //console.log("get position changed ", getPosition);
    if (getPosition) {
      formik.setFieldValue("id", getPosition.id);
      formik.setFieldValue("companyId", getPosition.companyId);
      formik.setFieldValue("name", getPosition.name);
      formik.setFieldValue("parentPositionId", getPosition.parentPositionId);
    }

    if (getPosition?.positionUsers) {
      if (getPosition?.positionUsers[0]) {
        console.log(
          "getPosition?.positionUsers[0]",
          getPosition?.positionUsers[0]
        );

        setSelectedOptionById(getPosition?.positionUsers[0].userId);
      } else {
        setSelectedOption(null);
        formik.setFieldValue("userId", null);
      }
    }

    if (getPosition?.positionsRoles) {
      const newListWithFlag = getRolesState.map((item: any) => ({
        ...item,
        flag: getPosition?.positionsRoles.some(
          (p: any) => p.roleId === item.id
        ),
      }));
      setRolesWithFlag(newListWithFlag);
    }
  }, [getPosition]);

  useEffect(() => {
    //console.log("UsersInfo", getUsersInfo);
    if (getUsersInfo) {
      console.log("selectedOptionId0", selectedOptionId);
      setOptionValue();
    }
  }, [getUsersInfo]);

  useEffect(() => {
    //console.log("get getRolesWithFlag changed ", getRolesWithFlag);

    if (getRolesWithFlag) {
      const filteredIds = getRolesWithFlag
        .filter((roles: any) => roles.flag) // Filter only the items where flag is true
        .map((roles: any) => roles.id); // Extract the IDs into a new array
      formik.setFieldValue("roles", filteredIds);
    }
  }, [getRolesWithFlag]);

  function handleChange(
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean
  ): void {
    setRolesWithFlag((prevArray: any) => {
      const newArray = prevArray.map((item: any) => {
        if (item.id === event.target.id) {
          return { ...item, flag: checked };
        }
        return item;
      });
      return newArray;
    });
  }

  const setSelectedOptionById = (id: any) => {
    setSelectedOptionId(id);
    formik.setFieldValue("userId", id);
    console.log("getUsersInfo", getUsersInfo);

    const option = getUsersInfo.find((option: any) => option.id === id);
    console.log("option u ", option);

    setSelectedOption(option);
    //setSelectedOption(option || null);
  };

  const handleOptionChange = (event: any, option: any) => {
    //alert(option.id);

    if (option) {
      formik.setFieldValue("userId", option.id);
      setSelectedOption(option);
    }
  };
  return (
    <>
      <div className="mx-2">
        <div className="card p-2">
          <div className="col-lg-12  col-xs-12 d-md-inline-flex  d-lg-inline-flex d-sm-block d-xs-inline-block">
            <div className="  mb-2 col-12 d-block">
              <div className="col-12" style={{ display: "block" }}>
                <TextField
                  {...formik.getFieldProps("name")}
                  sx={{
                    "& label": {
                      left: "unset",
                      right: "1.75rem",
                      transformOrigin: "right",
                      fontSize: "1rem",
                    },
                    "& legend": {
                      textAlign: "right",
                      fontSize: "1rem",
                    },
                  }}
                  fullWidth
                  className="block mb-2  iran"
                  id="name"
                  label="سمت"
                  placeholder={
                    getPosition?.name == undefined ? "سمت" : getPosition.name
                  }
                  variant="outlined"
                />
                {formik.touched.name && formik.errors.name ? (
                  <b
                    style={{ fontSize: "0.65rem" }}
                    className="my-1 text-danger iran"
                  >
                    {formik.errors.name}{" "}
                  </b>
                ) : null}
              </div>
              <div className="col-12" style={{ display: "block" }}>
                <Autocomplete
                  sx={{
                    "& label": {
                      left: "unset",
                      right: "1.75rem",
                      transformOrigin: "right",
                      fontSize: "1rem",
                    },
                    "& legend": {
                      textAlign: "right",
                      fontSize: "1rem",
                    },
                    paddingRight: "0px",
                  }}
                  dir="rtl"
                  disablePortal
                  id="combo-box-demo"
                  options={getUsersInfo}
                  value={selectedOption}
                  onChange={handleOptionChange}
                  getOptionLabel={(option: any) => option.name}
                  renderInput={(params) => (
                    <TextField
                      sx={{ paddingRight: "0px" }}
                      {...params}
                      label="کاربر"
                    />
                  )}
                  popupIcon={
                    <ArrowDropDown
                      style={{
                        position: "relative",
                        float: "left",
                      }}
                    />
                  }
                />
              </div>
              <div className="col-12" style={{ display: "block" }}>
                {getRolesWithFlag
                  ?.sort((a: any, b: any) =>
                    a.localizedName.localeCompare(b.localizedName)
                  )
                  ?.map((p: any) => (
                    <FormControlLabel
                      key={p.id}
                      className="iran"
                      sx={{ display: "block" }}
                      control={
                        <Checkbox
                          id={p.id}
                          checked={p.flag}
                          onChange={handleChange}
                        />
                      }
                      label={p.localizedName}
                    />
                  ))}
              </div>
            </div>
          </div>
          <div className="col-12 " dir="ltr" style={{ width: "100%" }}>
            <Button
              onClick={() => navigate("/Manage/Positions")}
              variant="outlined"
              color="warning"
              style={{ width: "6rem" }}
              className="iran "
              startIcon={<ClearIcon />}
            >
              انصراف
            </Button>
            <Button
              onClick={formik.submitForm}
              style={{ width: "6rem" }}
              variant="outlined"
              color="success"
              className="iran mx-2"
              startIcon={<SaveAsIcon />}
            >
              ذخیره
            </Button>
            <Button
              onClick={DeletePosition}
              style={{ width: "6rem" }}
              variant="outlined"
              color="error"
              className="iran"
              startIcon={<DeleteIcon />}
            >
              حذف
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default ManagePosition;
